import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {VideoForm} from "../forms";
import {videoService} from "../../services";
import {forms, strings} from "@atttomyx/shared-utils";
import {sortingUtils} from "../../utils";

const toData = (video) => {
    return {
        title: video.title,
        youTubeId: video.youTubeId,
        ranks: video.ranks,
        order: video.order,
        valid: strings.isNotBlank(video.title) && strings.isNotBlank(video.youTubeId) && sortingUtils.isSortable(video.order),
    }
};

const EditVideoDialog = (props) => {
    const { snackbar, video, onCancel, onSave } = props;
    const [ data, setData ] = useState(toData(video));
    const [ saving, setSaving ] = useState(false);

    const submitForm = () => {
        setSaving(true);

        const success = (saved) => {
            snackbar.setSuccess(saved.title + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        const modified = {
            title: data.title,
            youTubeId: data.youTubeId,
            ranks: data.ranks,
            order: data.order,
        };

        videoService.saveVideo(video.id, modified, success, failure);
    }

    return <Dialog
        open={true}
        aria-labelledby="edit-video-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Edit Video
        </ClosableDialogTitle>
        <DialogContent className="edit-video-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <VideoForm
                    data={data}
                    onChange={setData}
                    showRanks={true}
                    showOrder={true}
                />}
        </DialogContent>
        {!saving ? <DialogActions>
            <Button color="primary"
                    disabled={!data.valid || !forms.differ(toData(video), data)}
                    onClick={submitForm}>
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default EditVideoDialog;
